module.exports = __webpack_public_path__ + "static/media/dea23ea688f33aaa67ae9e1c158583b0.8df66944.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/dea23ea688f33aaa67ae9e1c158583b0.jpg
// module id = 272
// module chunks = 0